/**
 * Supported colors
 */
var COLOR_CLASSES;
(function (COLOR_CLASSES) {
    COLOR_CLASSES["BRAND_DEFAULT"] = "brand-default";
    COLOR_CLASSES["BRAND_PRIMARY"] = "brand-primary";
    COLOR_CLASSES["BRAND_SECONDARY"] = "brand-secondary";
    COLOR_CLASSES["BRAND_LIGHT"] = "brand-light";
    COLOR_CLASSES["BRAND_ACTIVE"] = "brand-active";
    COLOR_CLASSES["BRAND_WARNING"] = "brand-warning";
    COLOR_CLASSES["BRAND_INFO"] = "brand-info";
    COLOR_CLASSES["BRAND_DANGER"] = "brand-danger";
    COLOR_CLASSES["BRAND_SUCCESS"] = "brand-success";
    COLOR_CLASSES["BRAND_DARK"] = "brand-dark";
    COLOR_CLASSES["BRAND_HIGHLIGHT"] = "brand-highlight";
    COLOR_CLASSES["SEN_DEFAULT"] = "sen-default";
    COLOR_CLASSES["SEN_WARNING"] = "sen-warning";
    COLOR_CLASSES["SEN_POSITIVE"] = "sen-positive";
    COLOR_CLASSES["SEN_POSITIVE_ALT"] = "sen-positive-alt";
    COLOR_CLASSES["SEN_NEUTRAL"] = "sen-neutral";
    COLOR_CLASSES["SEN_NEUTRAL_ALT"] = "sen-neutral-alt";
    COLOR_CLASSES["SEN_NEGATIVE"] = "sen-negative";
    COLOR_CLASSES["SEN_NEGATIVE_ALT"] = "sen-negative-alt";
})(COLOR_CLASSES || (COLOR_CLASSES = {}));
export { COLOR_CLASSES };
//# sourceMappingURL=Styles.js.map